import titleCase from "utils/formatters/titleCase";

function formatPersonal(data) {
    const lastLoginDate =
        data.lastLogin === undefined
            ? "-"
            : new Date(data.lastLogin).toLocaleDateString();

    return {
        role: data.userRole,
        firstName: titleCase(data.profile.firstName),
        lastName: titleCase(data.profile.lastName),
        fullName: titleCase(
            `${data.profile.firstName} ${data.profile.lastName}`
        ),
        username: data.profile.login.toLowerCase(),
        lastLogin: lastLoginDate,
        repCrd: data?.repCrd,
        firmName: data?.firmName,
        firmId: data?.firmId,
        plAgentId: data?.plAgentId,
        dealer: data?.dealer,
        agency: data?.agency,
        agentId: data?.agentId
    };
}

function formatFactors(data) {
    const factors = {};
    data.forEach(({ factorType, id, status, profile }) => {
        const phone = profile.phoneExtension ? `${profile.phoneNumber}-${profile.phoneExtension}` : profile.phoneNumber;
        const factorValue = profile.email || phone;
        factors[factorType] = { id, status, factorValue };
    });
    return factors;
}

export { formatPersonal, formatFactors };
